import { motion } from 'framer-motion';
import { Github, Linkedin, Twitter, Mail, Youtube } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SocialLink {
  platform: 'github' | 'linkedin' | 'twitter' | 'email' | 'youtube';
  url: string;
  label: string;
}

interface SocialLinksProps {
  links: ReadonlyArray<SocialLink> | SocialLink[];
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

const SocialLinks = ({ 
  links, 
  orientation = 'horizontal',
  className 
}: SocialLinksProps) => {
  const getIcon = (platform: string) => {
    switch (platform) {
      case 'github':
        return <Github className="h-5 w-5" />;
      case 'linkedin':
        return <Linkedin className="h-5 w-5" />;
      case 'twitter':
        return <Twitter className="h-5 w-5" />;
      case 'email':
        return <Mail className="h-5 w-5" />;
      case 'youtube':
        return <Youtube className="h-5 w-5" />;
      default:
        return null;
    }
  };

  return (
    <ul className={cn(
      orientation === 'horizontal' ? 'flex space-x-4' : 'flex flex-col space-y-4',
      className
    )}>
      {links.map((link) => (
        <li key={link.platform}>
          <motion.a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              "inline-flex items-center justify-center",
              "w-10 h-10 rounded-full border border-border",
              "text-foreground/80 hover:text-primary hover:border-primary",
              "transition-all duration-300 ease-in-out"
            )}
            aria-label={link.label}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            {getIcon(link.platform)}
          </motion.a>
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks;
